import { render, staticRenderFns } from "./ReviewsAmenities.vue?vue&type=template&id=afca752c&"
import script from "./ReviewsAmenities.vue?vue&type=script&lang=js&"
export * from "./ReviewsAmenities.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsAmenities.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports